"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryHasCidResponse = exports.QueryHasCidRequest = exports.QueryGetCidSizeResponse = exports.QueryGetCidSizeRequest = exports.QueryGetCidResponse = exports.QueryGetCidRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.QueryRecordsByOwnerResponse = exports.QueryRecordsByOwnerRequest = exports.QueryRecordsByFingerprintResponse = exports.QueryRecordsByFingerprintRequest = exports.QueryRecordsByIdResponse = exports.QueryRecordsByIdRequest = exports.QueryResponseRecord = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const params_1 = require("../iscn/params");
exports.protobufPackage = "likechain.iscn";
const baseQueryResponseRecord = { ipld: "" };
exports.QueryResponseRecord = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ipld !== "") {
            writer.uint32(10).string(message.ipld);
        }
        if (message.data.length !== 0) {
            writer.uint32(18).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryResponseRecord);
        message.data = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ipld = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryResponseRecord);
        message.data = new Uint8Array();
        if (object.ipld !== undefined && object.ipld !== null) {
            message.ipld = String(object.ipld);
        }
        else {
            message.ipld = "";
        }
        if (object.data !== undefined && object.data !== null) {
            message.data = bytesFromBase64(object.data);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ipld !== undefined && (obj.ipld = message.ipld);
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryResponseRecord);
        if (object.ipld !== undefined && object.ipld !== null) {
            message.ipld = object.ipld;
        }
        else {
            message.ipld = "";
        }
        if (object.data !== undefined && object.data !== null) {
            message.data = object.data;
        }
        else {
            message.data = new Uint8Array();
        }
        return message;
    },
};
const baseQueryRecordsByIdRequest = {
    iscnId: "",
    fromVersion: long_1.default.UZERO,
    toVersion: long_1.default.UZERO,
};
exports.QueryRecordsByIdRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.iscnId !== "") {
            writer.uint32(10).string(message.iscnId);
        }
        if (!message.fromVersion.isZero()) {
            writer.uint32(16).uint64(message.fromVersion);
        }
        if (!message.toVersion.isZero()) {
            writer.uint32(24).uint64(message.toVersion);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRecordsByIdRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.iscnId = reader.string();
                    break;
                case 2:
                    message.fromVersion = reader.uint64();
                    break;
                case 3:
                    message.toVersion = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRecordsByIdRequest);
        if (object.iscnId !== undefined && object.iscnId !== null) {
            message.iscnId = String(object.iscnId);
        }
        else {
            message.iscnId = "";
        }
        if (object.fromVersion !== undefined && object.fromVersion !== null) {
            message.fromVersion = long_1.default.fromString(object.fromVersion);
        }
        else {
            message.fromVersion = long_1.default.UZERO;
        }
        if (object.toVersion !== undefined && object.toVersion !== null) {
            message.toVersion = long_1.default.fromString(object.toVersion);
        }
        else {
            message.toVersion = long_1.default.UZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.iscnId !== undefined && (obj.iscnId = message.iscnId);
        message.fromVersion !== undefined &&
            (obj.fromVersion = (message.fromVersion || long_1.default.UZERO).toString());
        message.toVersion !== undefined &&
            (obj.toVersion = (message.toVersion || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRecordsByIdRequest);
        if (object.iscnId !== undefined && object.iscnId !== null) {
            message.iscnId = object.iscnId;
        }
        else {
            message.iscnId = "";
        }
        if (object.fromVersion !== undefined && object.fromVersion !== null) {
            message.fromVersion = object.fromVersion;
        }
        else {
            message.fromVersion = long_1.default.UZERO;
        }
        if (object.toVersion !== undefined && object.toVersion !== null) {
            message.toVersion = object.toVersion;
        }
        else {
            message.toVersion = long_1.default.UZERO;
        }
        return message;
    },
};
const baseQueryRecordsByIdResponse = {
    owner: "",
    latestVersion: long_1.default.UZERO,
};
exports.QueryRecordsByIdResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.owner !== "") {
            writer.uint32(10).string(message.owner);
        }
        if (!message.latestVersion.isZero()) {
            writer.uint32(16).uint64(message.latestVersion);
        }
        for (const v of message.records) {
            exports.QueryResponseRecord.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRecordsByIdResponse);
        message.records = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.owner = reader.string();
                    break;
                case 2:
                    message.latestVersion = reader.uint64();
                    break;
                case 3:
                    message.records.push(exports.QueryResponseRecord.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRecordsByIdResponse);
        message.records = [];
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = String(object.owner);
        }
        else {
            message.owner = "";
        }
        if (object.latestVersion !== undefined && object.latestVersion !== null) {
            message.latestVersion = long_1.default.fromString(object.latestVersion);
        }
        else {
            message.latestVersion = long_1.default.UZERO;
        }
        if (object.records !== undefined && object.records !== null) {
            for (const e of object.records) {
                message.records.push(exports.QueryResponseRecord.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.owner !== undefined && (obj.owner = message.owner);
        message.latestVersion !== undefined &&
            (obj.latestVersion = (message.latestVersion || long_1.default.UZERO).toString());
        if (message.records) {
            obj.records = message.records.map((e) => e ? exports.QueryResponseRecord.toJSON(e) : undefined);
        }
        else {
            obj.records = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRecordsByIdResponse);
        message.records = [];
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = object.owner;
        }
        else {
            message.owner = "";
        }
        if (object.latestVersion !== undefined && object.latestVersion !== null) {
            message.latestVersion = object.latestVersion;
        }
        else {
            message.latestVersion = long_1.default.UZERO;
        }
        if (object.records !== undefined && object.records !== null) {
            for (const e of object.records) {
                message.records.push(exports.QueryResponseRecord.fromPartial(e));
            }
        }
        return message;
    },
};
const baseQueryRecordsByFingerprintRequest = {
    fingerprint: "",
    fromSequence: long_1.default.UZERO,
};
exports.QueryRecordsByFingerprintRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.fingerprint !== "") {
            writer.uint32(10).string(message.fingerprint);
        }
        if (!message.fromSequence.isZero()) {
            writer.uint32(16).uint64(message.fromSequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRecordsByFingerprintRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fingerprint = reader.string();
                    break;
                case 2:
                    message.fromSequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRecordsByFingerprintRequest);
        if (object.fingerprint !== undefined && object.fingerprint !== null) {
            message.fingerprint = String(object.fingerprint);
        }
        else {
            message.fingerprint = "";
        }
        if (object.fromSequence !== undefined && object.fromSequence !== null) {
            message.fromSequence = long_1.default.fromString(object.fromSequence);
        }
        else {
            message.fromSequence = long_1.default.UZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.fingerprint !== undefined &&
            (obj.fingerprint = message.fingerprint);
        message.fromSequence !== undefined &&
            (obj.fromSequence = (message.fromSequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRecordsByFingerprintRequest);
        if (object.fingerprint !== undefined && object.fingerprint !== null) {
            message.fingerprint = object.fingerprint;
        }
        else {
            message.fingerprint = "";
        }
        if (object.fromSequence !== undefined && object.fromSequence !== null) {
            message.fromSequence = object.fromSequence;
        }
        else {
            message.fromSequence = long_1.default.UZERO;
        }
        return message;
    },
};
const baseQueryRecordsByFingerprintResponse = {
    nextSequence: long_1.default.UZERO,
};
exports.QueryRecordsByFingerprintResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.records) {
            exports.QueryResponseRecord.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (!message.nextSequence.isZero()) {
            writer.uint32(16).uint64(message.nextSequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRecordsByFingerprintResponse);
        message.records = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.records.push(exports.QueryResponseRecord.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.nextSequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRecordsByFingerprintResponse);
        message.records = [];
        if (object.records !== undefined && object.records !== null) {
            for (const e of object.records) {
                message.records.push(exports.QueryResponseRecord.fromJSON(e));
            }
        }
        if (object.nextSequence !== undefined && object.nextSequence !== null) {
            message.nextSequence = long_1.default.fromString(object.nextSequence);
        }
        else {
            message.nextSequence = long_1.default.UZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.records) {
            obj.records = message.records.map((e) => e ? exports.QueryResponseRecord.toJSON(e) : undefined);
        }
        else {
            obj.records = [];
        }
        message.nextSequence !== undefined &&
            (obj.nextSequence = (message.nextSequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRecordsByFingerprintResponse);
        message.records = [];
        if (object.records !== undefined && object.records !== null) {
            for (const e of object.records) {
                message.records.push(exports.QueryResponseRecord.fromPartial(e));
            }
        }
        if (object.nextSequence !== undefined && object.nextSequence !== null) {
            message.nextSequence = object.nextSequence;
        }
        else {
            message.nextSequence = long_1.default.UZERO;
        }
        return message;
    },
};
const baseQueryRecordsByOwnerRequest = {
    owner: "",
    fromSequence: long_1.default.UZERO,
};
exports.QueryRecordsByOwnerRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.owner !== "") {
            writer.uint32(10).string(message.owner);
        }
        if (!message.fromSequence.isZero()) {
            writer.uint32(16).uint64(message.fromSequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRecordsByOwnerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.owner = reader.string();
                    break;
                case 2:
                    message.fromSequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRecordsByOwnerRequest);
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = String(object.owner);
        }
        else {
            message.owner = "";
        }
        if (object.fromSequence !== undefined && object.fromSequence !== null) {
            message.fromSequence = long_1.default.fromString(object.fromSequence);
        }
        else {
            message.fromSequence = long_1.default.UZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.owner !== undefined && (obj.owner = message.owner);
        message.fromSequence !== undefined &&
            (obj.fromSequence = (message.fromSequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRecordsByOwnerRequest);
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = object.owner;
        }
        else {
            message.owner = "";
        }
        if (object.fromSequence !== undefined && object.fromSequence !== null) {
            message.fromSequence = object.fromSequence;
        }
        else {
            message.fromSequence = long_1.default.UZERO;
        }
        return message;
    },
};
const baseQueryRecordsByOwnerResponse = { nextSequence: long_1.default.UZERO };
exports.QueryRecordsByOwnerResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.records) {
            exports.QueryResponseRecord.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (!message.nextSequence.isZero()) {
            writer.uint32(16).uint64(message.nextSequence);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRecordsByOwnerResponse);
        message.records = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.records.push(exports.QueryResponseRecord.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.nextSequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRecordsByOwnerResponse);
        message.records = [];
        if (object.records !== undefined && object.records !== null) {
            for (const e of object.records) {
                message.records.push(exports.QueryResponseRecord.fromJSON(e));
            }
        }
        if (object.nextSequence !== undefined && object.nextSequence !== null) {
            message.nextSequence = long_1.default.fromString(object.nextSequence);
        }
        else {
            message.nextSequence = long_1.default.UZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.records) {
            obj.records = message.records.map((e) => e ? exports.QueryResponseRecord.toJSON(e) : undefined);
        }
        else {
            obj.records = [];
        }
        message.nextSequence !== undefined &&
            (obj.nextSequence = (message.nextSequence || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRecordsByOwnerResponse);
        message.records = [];
        if (object.records !== undefined && object.records !== null) {
            for (const e of object.records) {
                message.records.push(exports.QueryResponseRecord.fromPartial(e));
            }
        }
        if (object.nextSequence !== undefined && object.nextSequence !== null) {
            message.nextSequence = object.nextSequence;
        }
        else {
            message.nextSequence = long_1.default.UZERO;
        }
        return message;
    },
};
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromJSON(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromPartial(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
};
const baseQueryGetCidRequest = { cid: "" };
exports.QueryGetCidRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetCidRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cid = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetCidRequest);
        if (object.cid !== undefined && object.cid !== null) {
            message.cid = String(object.cid);
        }
        else {
            message.cid = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.cid !== undefined && (obj.cid = message.cid);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetCidRequest);
        if (object.cid !== undefined && object.cid !== null) {
            message.cid = object.cid;
        }
        else {
            message.cid = "";
        }
        return message;
    },
};
const baseQueryGetCidResponse = {};
exports.QueryGetCidResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) {
            writer.uint32(10).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetCidResponse);
        message.data = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetCidResponse);
        message.data = new Uint8Array();
        if (object.data !== undefined && object.data !== null) {
            message.data = bytesFromBase64(object.data);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetCidResponse);
        if (object.data !== undefined && object.data !== null) {
            message.data = object.data;
        }
        else {
            message.data = new Uint8Array();
        }
        return message;
    },
};
const baseQueryGetCidSizeRequest = { cid: "" };
exports.QueryGetCidSizeRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetCidSizeRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cid = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetCidSizeRequest);
        if (object.cid !== undefined && object.cid !== null) {
            message.cid = String(object.cid);
        }
        else {
            message.cid = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.cid !== undefined && (obj.cid = message.cid);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetCidSizeRequest);
        if (object.cid !== undefined && object.cid !== null) {
            message.cid = object.cid;
        }
        else {
            message.cid = "";
        }
        return message;
    },
};
const baseQueryGetCidSizeResponse = { size: long_1.default.UZERO };
exports.QueryGetCidSizeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.size.isZero()) {
            writer.uint32(8).uint64(message.size);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetCidSizeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.size = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetCidSizeResponse);
        if (object.size !== undefined && object.size !== null) {
            message.size = long_1.default.fromString(object.size);
        }
        else {
            message.size = long_1.default.UZERO;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.size !== undefined &&
            (obj.size = (message.size || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetCidSizeResponse);
        if (object.size !== undefined && object.size !== null) {
            message.size = object.size;
        }
        else {
            message.size = long_1.default.UZERO;
        }
        return message;
    },
};
const baseQueryHasCidRequest = { cid: "" };
exports.QueryHasCidRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.cid !== "") {
            writer.uint32(10).string(message.cid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryHasCidRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cid = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryHasCidRequest);
        if (object.cid !== undefined && object.cid !== null) {
            message.cid = String(object.cid);
        }
        else {
            message.cid = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.cid !== undefined && (obj.cid = message.cid);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryHasCidRequest);
        if (object.cid !== undefined && object.cid !== null) {
            message.cid = object.cid;
        }
        else {
            message.cid = "";
        }
        return message;
    },
};
const baseQueryHasCidResponse = { exist: false };
exports.QueryHasCidResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.exist === true) {
            writer.uint32(8).bool(message.exist);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryHasCidResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.exist = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryHasCidResponse);
        if (object.exist !== undefined && object.exist !== null) {
            message.exist = Boolean(object.exist);
        }
        else {
            message.exist = false;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryHasCidResponse);
        if (object.exist !== undefined && object.exist !== null) {
            message.exist = object.exist;
        }
        else {
            message.exist = false;
        }
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.RecordsById = this.RecordsById.bind(this);
        this.RecordsByFingerprint = this.RecordsByFingerprint.bind(this);
        this.RecordsByOwner = this.RecordsByOwner.bind(this);
        this.Params = this.Params.bind(this);
        this.GetCid = this.GetCid.bind(this);
        this.HasCid = this.HasCid.bind(this);
        this.GetCidSize = this.GetCidSize.bind(this);
    }
    RecordsById(request) {
        const data = exports.QueryRecordsByIdRequest.encode(request).finish();
        const promise = this.rpc.request("likechain.iscn.Query", "RecordsById", data);
        return promise.then((data) => exports.QueryRecordsByIdResponse.decode(new minimal_1.default.Reader(data)));
    }
    RecordsByFingerprint(request) {
        const data = exports.QueryRecordsByFingerprintRequest.encode(request).finish();
        const promise = this.rpc.request("likechain.iscn.Query", "RecordsByFingerprint", data);
        return promise.then((data) => exports.QueryRecordsByFingerprintResponse.decode(new minimal_1.default.Reader(data)));
    }
    RecordsByOwner(request) {
        const data = exports.QueryRecordsByOwnerRequest.encode(request).finish();
        const promise = this.rpc.request("likechain.iscn.Query", "RecordsByOwner", data);
        return promise.then((data) => exports.QueryRecordsByOwnerResponse.decode(new minimal_1.default.Reader(data)));
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("likechain.iscn.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    GetCid(request) {
        const data = exports.QueryGetCidRequest.encode(request).finish();
        const promise = this.rpc.request("likechain.iscn.Query", "GetCid", data);
        return promise.then((data) => exports.QueryGetCidResponse.decode(new minimal_1.default.Reader(data)));
    }
    HasCid(request) {
        const data = exports.QueryHasCidRequest.encode(request).finish();
        const promise = this.rpc.request("likechain.iscn.Query", "HasCid", data);
        return promise.then((data) => exports.QueryHasCidResponse.decode(new minimal_1.default.Reader(data)));
    }
    GetCidSize(request) {
        const data = exports.QueryGetCidSizeRequest.encode(request).finish();
        const promise = this.rpc.request("likechain.iscn.Query", "GetCidSize", data);
        return promise.then((data) => exports.QueryGetCidSizeResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob ||
    ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = globalThis.btoa ||
    ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr) {
        bin.push(String.fromCharCode(byte));
    }
    return btoa(bin.join(""));
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=query.js.map